import styles from './ChartCustomTooltip.module.css';

const TOOLTIP_WIDTH = 150;
const TOOLTIP_HEIGHT = 62;
const TOOLTIP_GAP = 8;

type ChartCustomTooltipProps = {
  cx: number;
  cy: number;
  value: string;
  date: string;
};

const ChartCustomTooltip = ({
  cx,
  cy,
  value,
  date,
}: ChartCustomTooltipProps) => (
  <foreignObject
    x={cx - TOOLTIP_WIDTH / 2}
    y={cy - TOOLTIP_HEIGHT - TOOLTIP_GAP}
    width={TOOLTIP_WIDTH}
    height={TOOLTIP_HEIGHT}
    pointerEvents='none'
    overflow='visible'
  >
    <div className={styles.anchor}>
      <div className={styles.tooltip}>
        <span className={styles.value}>{value}</span>
        <span className={styles.date}>{date}</span>
      </div>
    </div>
  </foreignObject>
);

export default ChartCustomTooltip;
